export default __webpack_public_path__ + "static/media/user-login.e61bcd83.png";